import React, { useEffect, useRef, useState } from "react";

import { Button } from "reactstrap";
import cx from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useMetaMask } from "metamask-react";
import { useHistory, useLocation } from "react-router";

import {
	loginMarketUser,
	logoutMarketUser,
} from "../../../../_redux/actions/market";

import PathHelper from "../../PathHelper";

import { trimKey } from "../../../../helpers/Utils";
import Icon from "../../../../components/Icon/Icon";
import ArrowLeftIcon from "../../../../components/Icon/icons/account/ArrowLeftIcon";

import s from "./MarketAvatarWidget.module.scss";

export default function MarketAvatarWidget() {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const meta = useMetaMask();

	const [showLogout, setShowLogout] = useState(false);
	const [user, setUser] = useState(null);

	const market = useSelector((state) => state.market || {});
	const stateUser = market.user;
	const tooltipCopyRef = useRef(null);

	useEffect(() => {
		if (stateUser) return;

		const searchParams = new URLSearchParams(location.search);
		if (!searchParams) return;

		const name = searchParams.get("name");
		const publicKey = searchParams.get("publicKey");
		const avatar = searchParams.get("avatar");

		// Set user from Weave
		if (name && publicKey) {
			setUser({ name, publicKey, avatar });

			// Set user from metamask
		} else if (meta?.status === "connected") {
			setUser({
				metamaskAccount: meta.account,
				avatar: "metamask",
			});
		} else {
			setUser(null);
		}

		if (user) {
			dispatch(loginMarketUser(user));
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	useEffect(() => {
		if (stateUser) {
			setUser(stateUser);
		}
	}, [stateUser]);

	// ------------------------------------- METHODS -------------------------------------
	const onLogin = () => {
		history.push(PathHelper.getPath("market", "login/index"));
	};
	const onLogout = () => {
		setUser(null);
		dispatch(logoutMarketUser()).then(() => {
			history.push(PathHelper.getPath("market", ""));
		});
	};

	return (
		<div
			className={s.root}
			onMouseEnter={() => setShowLogout(true)}
			onMouseLeave={() => setShowLogout(false)}
		>
			{user ? (
				<div className={s.avatarContainer}>
					<div className={s.accountContainer} ref={tooltipCopyRef}>
						<p className={s.account}>
							{user?.name || trimKey(user?.metamaskAccount, true) || "no name"}
						</p>
						{user?.publicKey && (
							<div className={s.key}>{trimKey(user.publicKey)}</div>
						)}
					</div>

					<Icon icon={user.avatar} className={s.avatar} />

					{showLogout ? (
						<div className={s.logoutButton} onClick={onLogout}>
							<ArrowLeftIcon />
							<p className={s.logoutText}>Logout</p>
						</div>
					) : null}
				</div>
			) : (
				<Button
					className={cx(s.button, "btn-default dark")}
					color="primary"
					onClick={onLogin}
				>
					<Icon icon="fox" />
					<span>Connect Wallet</span>
				</Button>
			)}
		</div>
	);
}
